import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { fetchFilesTypes } from "services/files-types.service";
import { FilesTypesEntity } from "types/Files";

// Define the types for your initial state
interface filesTypesContainerState {
  isLoading: boolean;
  isError: boolean;
  errMsg: string;
  collection: FilesTypesEntity[];
}

const initialState: filesTypesContainerState = {
  isLoading: true,
  isError: false,
  errMsg: "",
  collection: [],
};

const filesTypesContainerSlice = createSlice({
  name: "files-types",
  initialState,
  /* eslint-disable no-param-reassign */
  reducers: {
    setDestroy() {
      return initialState;
    },
    setLoading(
      state: filesTypesContainerState,
      action: PayloadAction<boolean>
    ) {
      state.isLoading = action.payload;
    },
    setError(
      state: filesTypesContainerState,
      action: PayloadAction<{ error: string }>
    ) {
      state.isLoading = false;
      state.isError = true;
      state.errMsg = action.payload.error;
    },
    setData(state: filesTypesContainerState, action: PayloadAction<any>) {
      state.collection = action.payload;
      state.isLoading = false;
      state.isError = false;
    },
  },
});

const { actions, reducer } = filesTypesContainerSlice;

export const { setDestroy, setLoading, setError, setData } = actions;
export default reducer;

// Only the newest request may change the state: after a company switch or a reload,
// an older answer would show the wrong list or an error that no longer applies.
let latestRequest = 0;

export const fetchFilesTypesList =
  (companyId: string) => async (dispatch: any) => {
    latestRequest += 1;
    const request = latestRequest;
    dispatch(setLoading(true));
    try {
      const data = await fetchFilesTypes(companyId);
      if (request === latestRequest) dispatch(setData(data));
    } catch (e) {
      const error = "not_fetch";
      if (request === latestRequest) dispatch(setError({ error }));
    }
  };
